import { Component, Input, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { AuditLogsExportComponent } from '../audit-logs-export/audit-logs-export.component';
import { AuditLogsRevisionComponent } from '../audit-logs-revision/audit-logs-revision.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-preview-audit-logs',
  templateUrl: './preview-audit-logs.component.html',
  styleUrls: ['./preview-audit-logs.component.scss']
})
export class PreviewAuditLogsComponent implements OnInit {
  subGetAuditLogDetailsList: SubscriptionLike;
  subGetAuditLogDetailsList1: SubscriptionLike;
  @Input() public Content : any
  gridApi: GridApi;
  selectedRow: any;
  columnDefs: any;
  rowData: any = [];
  public content: any;
  clonedauditLogSearch: IEGAuditLogSearch = {};
  log_data: any;
  details_data: any;
  versionids: any;
  category_name: any;
  related_pk_id: string;
  RevisionNo: any
  revisionDetails: RevisionDetails = new RevisionDetails();
  action: Subject<any> = new Subject();
  gridBar:boolean=false;
	gridOptions: { pagination: boolean; rowSelection: string; rowHeight: number; defaultColDef: { sortable: boolean; suppressNavigable: boolean; cellClass: string; suppressMovable: boolean; }; };
  context: any;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public appService: ApidataRequestService,
  ) { }

  ngOnInit(): void {
    this.gridBar=false;
    this.gridHeaderandActionSettings();
    this.clonedauditLogSearch = this.Content.content.IEGsearch;
    this.versionids = [];
    this.versionids.push(this.Content.content.VersionID.toString());
    this.category_name = this.Content.content.category_name;
    var post = {
      versionIDs: this.versionids
    };
    this.log_data = this.Content.content.log_data;

    this.subGetAuditLogDetailsList = this.appService.getDataPost("api/IEGAuditActivityLogs/GetIEGAuditLogMultiSummary", post).subscribe((result) => {
      if (result.Status && result.Data.length > 0) {
        this.rowData = result.Data;
        this.details_data = this.rowData;
        this.RevisionNo = this.rowData.map((item) => item.revision_num)
        //debugger
        this.related_pk_id = this.rowData[0].related_pk_id;
      } else {
        this.rowData = [];
        this.details_data = [];
      }
    });
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
    this.context = { componentParent: this };
  }

  ngOnDestroy(): void {
    if (this.subGetAuditLogDetailsList) this.subGetAuditLogDetailsList.unsubscribe();
    if (this.subGetAuditLogDetailsList1) this.subGetAuditLogDetailsList1.unsubscribe();

  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Revision #", headerTooltip: "Revision #", field: 'revision_num', sortable: false, resizable: true, tooltipField: 'revision_num' },
      { headerName: "Screen Name", headerTooltip: "Screen Name", field: "section_name", sortable: false, resizable: true, tooltipField: "section_name" },
      { headerName: "Field Name", headerTooltip: "Field Name", field: 'field_name', sortable: false, resizable: true, tooltipField: "field_name" },
      { headerName: "Old Value", headerTooltip: "Old Value", field: 'initial_value', sortable: false, resizable: true, tooltipField: "initial_value" },
      { headerName: "New Value", headerTooltip: "New Value", field: 'changed_value', sortable: false, resizable: true, tooltipField: "changed_value" },
      { headerName: "Changed On", headerTooltip: "Changed On", field: 'last_modified_date_string', sortable: false, resizable: true, tooltipField: "last_modified_date_string" },
      { headerName: "Changed By", headerTooltip: "Changed By", field: 'last_modified_by', sortable: false, resizable: true, tooltipField: "last_modified_by" }
    ];
  }


  onSetGridApi(params) {
    this.gridApi = params.api;;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnRevisionClick() {
    //debugger
    var search = this.clonedauditLogSearch;
    var heading = "";
    let modalRef = this.modalService.open(AuditLogsRevisionComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: heading,
      content: {
        ID: this.related_pk_id,
        OperationType: "View",
        search_data: search,
        RevisionNo:this.RevisionNo
      }
    }
    modalRef.result.then(result => {
      //debugger
      this.details_data = [];
      this.versionids = [];
      this.log_data = [];
      if (result != null) {
        for (var i = 0; i < result.length; i++) {
          var id = result[i]["VersionID"].toString();
          this.versionids.push(id);
          this.revisionDetails = new RevisionDetails();
          this.revisionDetails.Revision_num = result[i]["Revision_num"];
          this.revisionDetails.Last_modified_date = result[i]["Last_modified_date"];
          this.revisionDetails.Username = result[i]["Username"];
          this.log_data.push(this.revisionDetails);
        }
        var post = {
          versionIDs: this.versionids
        };
       // this.log_data = result;
        this.rowData = [];
        if (result.length > 0) {
          this.subGetAuditLogDetailsList1 = this.appService.getDataPost("api/IEGAuditActivityLogs/GetIEGAuditLogMultiSummary", post).subscribe((res) => {
            if (res.Status) {
              this.rowData = res.Data;
              this.RevisionNo = this.rowData.map((item) => item.revision_num)
              this.details_data = this.rowData;
            } else {
              this.rowData = [];
              this.details_data = [];
            }
          });
        }
      }
    });
  }

  cancelmodal() {
    this.modalRef.dismiss();
  }


  ExportToPDF() {
    //debugger
    var category = this.category_name;
    let modalRef = this.modalService.open(AuditLogsExportComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      content: {
        ID: null,
        OperationType: "View",
        log_data: this.log_data,
        details_data: this.details_data,
        category: category
      }
    }

  }
}
export class IEGAuditLogSearch {
  ModuleId?: string;
  ApplicationId?: string;
  ScreenName?: string;
  UserName?: string;
  StartDate?: string;
  EndDate?: string;
  OrgID?: string;
  cDetails?: string;
  cComp?: string;
  GrantType?: string;
}
export class RevisionDetails {
  Revision_num: string;
  Last_modified_date: string;
  Username: string;
}
